/* Copyright 2013 - 2024 Waiterio LLC */
/** @jsxImportSource @emotion/react */
import getCountryNameByCode from '@monorepool/shared/getCountryNameByCode.js'
import { useTranslation } from '@multilocale/react/index.jsx'
import allCities from '@waiterio/takeaway/cities.js'
import SearchJumbotron from '@waiterio/takeaway/components/SearchJumbotron.jsx'
import locales from '../locales.js'

export const paths = locales.map(locale => ({
  path: `/takeaway/${locale}/`,
  props: {
    locale,
  },
}))

export const Head = props => {
  const { locale } = props
  let [language, country] = locale.split('-')
  const { t } = useTranslation(language)
  const countryName = t(getCountryNameByCode(country), language)
  const title = `${t('Takeaway')} ${countryName} | Waiterio`
  const description = t(
    'Takeaway from the best restaurants nearby',
    language,
  ).replace('{country}', countryName)
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
    </>
  )
}

const CountryPage = props => {
  const { locale } = props
  let [language, country] = locale.split('-')
  const { t } = useTranslation(language)
  let cities = allCities.filter(
    city => city.countryCode.toUpperCase() === country.toUpperCase(),
  )
  return (
    <>
      <SearchJumbotron language={language} />
      <div css={{ textAlign: 'center' }}>
        <h1>{t('Cities')}</h1>
        {cities.map(city => (
          <a
            key={city.name}
            href={`/takeaway/${locale}/city-${city.name.toLowerCase()}`}
            css={{ display: 'block', padding: 8 }}
          >
            {city.name}
          </a>
        ))}
      </div>
    </>
  )
}

export default CountryPage
